import { Model } from "backbone";


export default class AppBase {
  constructor() {
    this.dispatcher = new Model();
  }

  init() {
    console.log(this.constructor.name, "[init]");
  }
}



// WEBPACK FOOTER //
// ./src/js/apps/AppBase.js